/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:59:26
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-12 11:39:31
 */
import i18n from "@/config/i18n";
import Vue from "vue";
import configData from "../config/config";
const common = {
    /**
     * 存本地数据
     * @param item 名字
     * @param str 数据
     * @param type 本地数据类型,没有  sessionStorage 有 localStorage
     */
    save(item, str, type) {
        const typeData = type || 0;
        if (typeof str == "object") {
            str = JSON.stringify(str);
        }
        const win = window;
        if (typeData) {
            win.localStorage.removeItem(item);
            win.localStorage[item] = str;
        }
        else {
            win.sessionStorage.removeItem(item);
            win.sessionStorage[item] = str;
        }
    },
    /**
     * 取本地数据
     * @param item 名字
     * @param type 本地数据类型,没有  sessionStorage 有  localStorage
     */
    get(item, type) {
        let value;
        const typeData = type || 0;
        const win = window;
        if (typeData) {
            if (win.localStorage[item] !== undefined) {
                value = win.localStorage[item];
                if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                    return JSON.parse(value);
                }
                else {
                    return value;
                }
            }
            else {
                return false;
            }
        }
        else {
            if (win.sessionStorage[item] !== undefined) {
                value = win.sessionStorage[item];
                if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                    return JSON.parse(value);
                }
                else {
                    return value;
                }
            }
            else {
                return false;
            }
        }
    },
    /**
     * 删除本地数据
     * @param name 名字
     * @param type 本地数据类型,没有 sessionStorage  有  localStorage
     */
    remove(name, type) {
        const typeData = type || 0;
        const item = name || "-1";
        const win = window;
        if (typeData) {
            if (item == "-1") {
                win.localStorage.clear();
            }
            else {
                win.localStorage.removeItem(item);
            }
        }
        else {
            if (item == "-1") {
                win.sessionStorage.clear();
            }
            else {
                win.sessionStorage.removeItem(item);
            }
        }
    },
    out() {
        this.remove();
        const win = window;
        if (configData.loginUrl) {
            win.location.href = configData.loginUrl;
        }
        else {
            win.history.go(0);
        }
    },
    parseParam(json) {
        const params = Object.keys(json)
            .map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
            .join("&");
        return params;
    },
    thisTimes: function (type, dateObj) {
        const d = dateObj || new Date();
        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        let dd = d.getDate();
        const day = d.getDay(); // 星期几
        let h = d.getHours(); // 时
        let f = d.getMinutes(); // 分
        let s = d.getSeconds(); // 秒
        y = y < 10 ? "0" + y : y;
        m = m < 10 ? "0" + m : m;
        h = h < 10 ? "0" + h : h;
        dd = dd < 10 ? "0" + dd : dd;
        f = f < 10 ? "0" + f : f;
        s = s < 10 ? "0" + s : s;
        let json = "";
        let yy = "";
        switch (type) {
            case "yy":
                json = y;
                break;
            case "mm":
                json = m;
                break;
            case "dd":
                json = dd;
                break;
            case "hh":
                json = h;
                break;
            case "ff":
                json = f;
                break;
            case "ss":
                json = s;
                break;
            case "day":
                json = day;
                break;
            case "days":
                json = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
                break;
            case "yyyy":
                json = y;
                break;
            case "yyyy-MM":
                json = y + "-" + m;
                break;
            case "yyyy-MM-s":
                yy = y + "";
                yy = yy.substring(yy.length - 3, yy.length - 1);
                json = yy + "-" + m;
                break;
            case "yyyy-MM-dd":
                json = y + "-" + m + "-" + dd;
                break;
            case "yyyy-MM-dd HH:MM":
                json = y + "-" + m + "-" + dd + " " + h + ":" + f;
                break;
            case "yyyy-MM-dd HH:MM:SS":
                json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
                break;
            case "HH:MM":
                json = h + ":" + f;
                break;
            default:
                json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
                break;
        }
        return json;
    },
    userDate: function (uData, type) {
        const myDate = new Date(uData);
        const year = this.t(myDate.getFullYear());
        const month = this.t(myDate.getMonth() + 1);
        const day = this.t(myDate.getDate());
        const hours = this.t(myDate.getHours());
        const minutes = this.t(myDate.getMinutes());
        const second = this.t(myDate.getSeconds());
        if (type === "yyyy-MM") {
            return year + "-" + month;
        }
        else if (type === "yyyy-MM-dd") {
            return year + "-" + month + "-" + day;
        }
        else if (type === "HH:MM") {
            return hours + ":" + minutes;
        }
        else {
            return (year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hours +
                ":" +
                minutes +
                ":" +
                second);
        }
    },
    t(time) {
        if (time < 10) {
            return "0" + time;
        }
        else {
            return time;
        }
    },
    tableNoData(text) {
        const tableText = text || i18n.t("noData");
        return ("<div class='table-no-data'><i class='ivu-icon ivu-icon-ios-folder-open-outline'></i><p>" +
            tableText +
            "</p></div>");
    },
    imgShowUrl(str) {
        const pos = str.indexOf(configData.fileImg);
        let url = str.substring(pos, str.length);
        url = url.replace(configData.fileImg, "");
        return url;
    },
    debounce(func, timeout) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func(...args);
            }, timeout);
        };
    },
    request(paras) {
        const win = window;
        const url = decodeURIComponent(win.location.href);
        const paraString = url
            .substring(url.indexOf("?") + 1, url.length)
            .split("&");
        const paraObj = {};
        /* eslint-disable */
        var j;
        for (var i = 0; (j = paraString[i]); i++) {
            paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(j.indexOf('=') + 1, j.length);
        }
        /* eslint-enable */
        const returnValue = paraObj[paras.toLowerCase()];
        if (typeof returnValue === "undefined") {
            return "";
        }
        else {
            return returnValue;
        }
    },
    copyText(text) {
        const win = window;
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
            //区分iPhone设备
            const data = {};
            data.span = document.createElement("span");
            data.span.innerHTML = text;
            //span.style.display='none';
            data.span.id = "copyTextSpan";
            document.body.appendChild(data.span);
            win.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
            const range = document.createRange();
            // 选中需要复制的节点
            range.selectNode(data.span);
            // 执行选中元素
            win.getSelection().addRange(range);
            // 执行 copy 操作
            document.execCommand("copy");
            // 移除选中的元素
            win.getSelection().removeAllRanges();
            data.span["parentNode"].removeChild(data.span);
            Vue.prototype.$Message.success(i18n.t("formText.copySuccess"));
        }
        else {
            const data = {};
            data.oInput = document.createElement("textarea");
            data.oInput.value = text;
            document.body.appendChild(data.oInput);
            data.oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            data.oInput.className = "oInput";
            data.oInput.style.display = "none";
            data.oInput.parentNode.removeChild(data.oInput);
            Vue.prototype.$Message.success(i18n.t("formText.copySuccess"));
        }
    },
    /**
     * 0.x 换算成百分比参数
     */
    numBai(val) {
        if (typeof val == "string") {
            val = Number(val);
        }
        const num = (val * 100).toFixed(0);
        return parseFloat(num);
    },
    /**
     * 百分比参数换算成 0.x
     */
    baiNum(val) {
        if (typeof val == "string") {
            val = Number(val);
        }
        const num = (val / 100).toFixed(2);
        return parseFloat(num);
    },
};
export default common;
